<template>
  <div>
    <IndoorOrOutdoorRadioField
      :choices="choices"
      v-on="$listeners"
      @result="setServiceForSelection($event.value[0])"
    />

    <ServiceField ref="service" hidden v-on="$listeners" />
  </div>
</template>

<script>
import IndoorOrOutdoorRadioField from 'chimera/all/components/form/fields/indoorOrOutdoor/IndoorOrOutdoorRadioField'
import ServiceField from 'chimera/all/components/form/fields/service/ServiceField'
import { Selectable } from 'chimera/all/components/models/Selectable'
import { paintingIndoorNL, paintingOutdoorNL } from 'chimera/painting/service'

export default {
  name: 'IndoorOrOutdoorFormPart',

  components: {
    IndoorOrOutdoorRadioField,
    ServiceField,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      choices: [
        new Selectable(this.$t('indoor'), this.$t('indoor'), this.$t('indoor')),
        new Selectable(
          this.$t('outdoor'),
          this.$t('outdoor'),
          this.$t('outdoor'),
        ),
        new Selectable(this.$t('both'), this.$t('both'), this.$t('both')),
      ],
    }
  },

  methods: {
    /**
     * @param {object} selection
     * @param {string} selection.id
     */
    setServiceForSelection({ id }) {
      const serviceId =
        id === this.$t('outdoor') ? paintingOutdoorNL.id : paintingIndoorNL.id
      this.$refs.service.setValue(serviceId)
    },
  },
}
</script>

<i18n>
{
  "nl-NL": {
    "indoor": "Binnen",
    "outdoor": "Buiten",
    "both": "Beide"
  }
}
</i18n>
